function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.15,
  d: "M47.305 54.77L66.952.624v-.625h-18.42L35.026 54.77h12.28zm-34.291 0H.734L14.241-.001h18.42v.625L13.014 54.77z"
});

var SvgRightQuote = function SvgRightQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 55,
    viewBox: "0 0 67 55"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/right-quote.007ef33c.svg";
export { SvgRightQuote as ReactComponent };